export default "__VITE_ASSET__6VU3CplI__"